
import { CommonConstants } from '@/constants/common';

export default {
  mounted(el, binding, vnode) {
    el.addEventListener(
      'blur',
      (e) => {
        let value;
        if (!CommonConstants.ALPHABET_NUMERIC_VALIDATION_REGEX.test(e.target.value)) {
          value = e.target.value.replace(e.target.value, '');
        } else {
          value = e.target.value;
        }
        e.target.value = value;
        el.value = value;

        let event;
        if (typeof Event === 'function') {
          event = new Event('input', { bubbles: true });
        } else {
          event = document.createEvent('Event');
          event.initEvent('input', true, true);
        }
        vnode.el.dispatchEvent(event);
      },
      true
    );
  },
};
